import { render, staticRenderFns } from "./CatalogoRutaPDF.vue?vue&type=template&id=0a9f9e1f&scoped=true&"
import script from "./CatalogoRutaPDF.vue?vue&type=script&lang=ts&"
export * from "./CatalogoRutaPDF.vue?vue&type=script&lang=ts&"
import style0 from "./CatalogoRutaPDF.vue?vue&type=style&index=0&id=0a9f9e1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9f9e1f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCol,VContainer,VRow})
